import React from "react";
import templeImage from "../../images/temple-rakshak.jpg";
import { Link } from "react-router-dom";
export default function TempleRakshak() {
  return (
    <>
      <style>{`

      *{
        margin:0;
        padding:0;
        box-sizing:border-box;
      }

      body{
        font-family:"Poppins",sans-serif;
        background:#f3ead7;
      }

      .temple-page{
        width:100%;
        min-height:100vh;
        background: linear-gradient(to right, #ffdb5e 0%, #ffffff 100%);
        color:#222;
        padding:80px 0;
      }

      .container{
        width:92%;
        max-width:1200px;
        margin:auto;
      }

      /* MAIN TITLE */

      .main-title{
        text-align:center;
        margin-bottom:70px;
      }

      .main-title h1{
        font-size:48px;
        font-weight:900;
        color:#000;
        margin-bottom:20px;
        line-height:1.1;
      }

      .main-title h2{
        font-size:36px;
        font-weight:700;
        color:#8b5a00;
        line-height:1.3;
        margin-bottom:35px;
      }

      .main-title p{
        max-width:1000px;
        margin:auto;
        font-size:20px;
        line-height:1.5;
      }

      /* SECTION */

      .section{
        margin-bottom:65px;
      }

      .section-title{
        font-size:40px;
        font-weight:800;
        color:#8b5a00;
        margin-bottom:25px;
        line-height:1;
      }
      .section-titles{
        font-size:30px;
        font-weight:600;
        color:#8b5a00;
        margin-bottom:25px;
        line-height:1;
      }

      .section p{
        font-size:20px;
        line-height:1.5;
        margin-bottom:25px;
      }

      .section ul{
        padding-left:25px;
        margin-top:20px;
      }

      .section li{
        font-size:20px;
        line-height:1;
        margin-bottom:14px;
      }

      .price{
        font-size:38px;
        font-weight:700;
        color:#c58b2a;
        margin:20px 0 25px;
      }
.section-divider{
  width:100%;
  max-width:900px;
  margin:32px auto 38px;

  display:flex;
  align-items:center;
  justify-content:center;
  gap:18px;
}

.section-divider::before,
.section-divider::after{
  content:"";
  flex:1;
  height:3px;

  background: linear-gradient(
    to right,
    transparent,
    #1a2a5a,
    #d4af37,
    transparent
  );

  border-radius:10px;

  box-shadow:
    0 2px 6px rgba(0,0,0,0.18);
}

.section-divider span{
  font-size:26px;
  color:#1a2a5a;
  text-shadow:0 2px 6px rgba(0,0,0,0.15);

  animation: dividerGlow 2.5s ease-in-out infinite;
}
.intro-image{
  display:flex;
  justify-content:center;
  margin:40px 0 15px;
}

.intro-image img{
  width:100%;
  max-width:900px;
  border:8px solid #fff;
  border-radius:20px;
  box-shadow:
    0 12px 35px rgba(0,0,0,0.18),
    0 0 0 4px #e80707ff;
  transition:0.35s ease;
}

.intro-image img:hover{
  transform:scale(1.02);
  box-shadow:
    0 18px 45px rgba(0,0,0,0.25),
    0 0 0 4px #4a160eff;
}
.membership-box{
  display:flex;
  align-items:center;
  justify-content:space-between;
  gap:35px;
  margin:35px 0;
  padding:35px;
  background: linear-gradient(to right, #ffdb5e 0%, #ffffff 100%);
  border-radius:22px;
  border:3px solid #d4af37;
  box-shadow:0 15px 35px rgba(0,0,0,.12);
}

.membership-btn{
  display:inline-flex;
  align-items:center;
  justify-content:center;
  text-decoration:none;
  background:linear-gradient(135deg,#c58b2a,#f4c542);
  color:#fff;
  font-size:34px;
  font-weight:800;
  border:none;
  border-radius:18px;
  padding:22px 42px;
  cursor:pointer;
  transition:.35s;
  box-shadow:0 10px 25px rgba(197,139,42,.35);
  text-transform:uppercase;
}

.membership-btn:hover{
  color:#fff;
  text-decoration:none;
  transform:translateY(-4px) scale(1.04);
  box-shadow:0 18px 35px rgba(197,139,42,.45);
}

.payment-info{
  flex:1;
}

.payment-info h3{
  color:#8b5a00;
  font-size:24px;
  margin-bottom:18px;
}

.payment-info p{
  margin:10px 0 !important;
  font-size:20px !important;
  line-height:1.4 !important;
}

.payment-info strong{
  color:#1a2a5a;
}
.payment-row{
  display:flex;
  gap:25px;
  align-items:flex-start;
}

.payment-card{
  flex:1;
  font-size:20px;
  line-height:1.4;
}

.payment-card strong{
  color:#1a2a5a;
  font-size:21px;
}
      /* MOBILE */

@media (max-width: 768px) {
  .intro-image{
    margin:22px 0 10px;
  }

  .intro-image img{
    border:5px solid #fff;
    border-radius:14px;
    box-shadow:
      0 8px 20px rgba(0,0,0,0.18),
      0 0 0 3px #d4af37;
  }
  .temple-page{
    padding:40px 0;
  }

  .container{
    width:95%;
  }

  .main-title{
    margin-bottom:30px;
  }

  .main-title h1{
    font-size:24px;
    line-height:1.1;
    margin-bottom:12px;
  }

  .main-title h2{
    font-size:16px;
    line-height:1.2;
    margin-bottom:16px;
  }

  .main-title p{
    font-size:13px !important;
    line-height:1.4 !important;
  }

  .section{
    margin-bottom:32px;
  }

  .section-title{
    font-size:18px;
    line-height:1.2;
    margin-bottom:12px;
  }

  .section-titles{
    font-size:17px;
    line-height:1.2;
    margin-bottom:10px;
  }

  .section p{
    font-size:13px !important;
    line-height:1.4;
    margin-bottom:12px;
  }
  

  .section li{
    font-size:14px;
    line-height:1;
    margin-bottom:8px;
  }

  .section ul{
    padding-left:18px;
  }

  h4{
    font-size:14px;
    margin-bottom:8px;
  }

  .price{
    font-size:28px;
    margin:12px 0;
  }

  .section-divider{
    margin:16px auto 20px;
    gap:10px;
  }

  .section-divider span{
    font-size:16px;
  }

  .section-divider::before,
  .section-divider::after{
    height:2px;
  }
  .membership-box{
    flex-direction:column;
    text-align:center;
    padding:22px;
    gap:20px;
  }

  .membership-btn{
    width:100%;
    font-size:24px;
    padding:18px;
  }

  .payment-info h3{
    font-size:18px;
  }

  .payment-info p{
    font-size:15px !important;
  }
  .payment-row{
    flex-direction:column;
    gap:18px;
  }

  .payment-card{
    text-align:center;
    font-size:15px;
  }

  .payment-card strong{
    font-size:16px;
  }
}

      `}</style>

      <div className="temple-page">

        <div className="container">

  {/* MAIN TITLE */}

  <div className="main-title">

    <h1>A4H Temple Rakshak (Protector) – ATR</h1>

    <div className="section-divider">
      <span>✦ ✦ ✦</span>
    </div>

    <h2>A National Initiative of Americans4Hindus (A4H)</h2>

    <p>
      <strong>Protecting Temples, Empowering Communities, Strengthening America</strong>
    </p>

  </div>

  {/* INTRODUCTION */}

  <div className="section">

    <p>
      Americans4Hindus (A4H), dedicated to civic engagement, public service,
      and the protection of Hindu interests in America, proudly launches
      <strong> A4H Temple Rakshak (Protector) – ATR</strong>, a nationwide
      initiative designed to safeguard Hindu temples and empower them as
      centers of community service, civic participation, and cultural
      preservation.
    </p>
    <div className="intro-image">
      <img src={templeImage} alt="A4H Temple Rakshak" />
    </div>
  </div>
      
  {/* MISSION */}

  <div className="section">

    <h2 className="section-title">
      Mission
    </h2>

    <p>
      To protect, strengthen, and empower Hindu temples across the United
      States by enhancing security, promoting community engagement,
      fostering civic participation, and building strong relationships
      with local, state, and federal authorities.
    </p>

  </div>

  {/* KEY AREAS */}

  <div className="section">

    <h2 className="section-title">
      Key Areas of Focus
    </h2>

  </div>

  <div className="section">

    <h2 className="section-titles">
      1. Temple Security & Protection
    </h2>

    <p>
      ATR will assist temples in developing comprehensive security
      strategies to address:
    </p>

    <ul>
      <li>Temple vandalism and hate crimes</li>
      <li>Theft, robbery, and property damage</li>
      <li>Active violence prevention and emergency preparedness</li>
      <li>Cybersecurity protection for temple websites, databases, donations, and communications</li>
      <li>Security audits and risk assessments</li>
      <li>Installation of surveillance systems and best security practices</li>
      <li>Emergency response protocols</li>
    </ul>

  </div>

  <div className="section">

    <h2 className="section-titles">
      2. Law Enforcement & First Responder Partnerships
    </h2>

    <p>
      ATR will facilitate regular engagement between temples and:
    </p>

    <ul>
      <li>Police Chiefs</li>
      <li>Sheriffs</li>
      <li>Fire Chiefs</li>
      <li>Emergency Management Officials</li>
      <li>Homeland Security Representatives</li>
      <li>Local Government Leaders</li>
    </ul>

    <p>
      These partnerships will help create safer temple environments and
      establish rapid response mechanisms during emergencies.
    </p>

  </div>

  <div className="section">

    <h2 className="section-titles">
      3. Civic Engagement & Community Empowerment
    </h2>

    <p>
      ATR will encourage temples to become centers of civic participation
      by promoting:
    </p>

    <ul>
      <li>Citizenship workshops</li>
      <li>Voter registration drives</li>
      <li>Civic education programs</li>
      <li>Government outreach initiatives (GOV)</li>
      <li>Youth leadership development</li>
      <li>Public policy awareness programs</li>
      <li>Community volunteerism</li>
    </ul>

  </div>

  <div className="section">

    <h2 className="section-titles">
      4. Temples as Community Civic Centers
    </h2>

    <p>
      ATR will work with temples to become recognized hubs of democratic
      participation through:
    </p>

    <ul>
      <li>Hosting candidate forums</li>
      <li>Organizing public debates</li>
      <li>Town hall meetings</li>
      <li>Community listening sessions</li>
      <li>Serving as polling locations where legally permissible</li>
      <li>Facilitating interactions between elected officials and community members</li>
    </ul>

  </div>

  <div className="section">

    <h2 className="section-titles">
      5. Public Service & Community Outreach
    </h2>

    <p>
      Temples can significantly enhance their role in mainstream American
      society through:
    </p>

    <ul>
      <li>Food distribution programs</li>
      <li>Blood donation drives</li>
      <li>Health fairs and wellness camps</li>
      <li>Disaster relief efforts</li>
      <li>Environmental initiatives</li>
      <li>Educational and mentoring programs</li>
      <li>Senior citizen support services</li>
      <li>Interfaith and multicultural engagement</li>
    </ul>

  </div>

  <div className="section">

    <h2 className="section-titles">
      6. Hindu Heritage & Cultural Preservation
    </h2>

    <p>
      ATR will help temples:
    </p>

    <ul>
      <li>Preserve Hindu traditions and values</li>
      <li>Promote Dharma-based education</li>
      <li>Celebrate Hindu festivals with broader community participation</li>
      <li>Combat misinformation and Hinduphobia through awareness and education</li>
    </ul>

  </div>

  {/* IMPLEMENTATION */}

  <div className="section">

    <h2 className="section-title">
      Implementation Strategy
    </h2>

    <h2 className="section-titles">
      ATR State Coordinators
    </h2>

    <p>
      A4H will appoint state and regional ATR coordinators to support
      participating temples and provide resources, training, and guidance.
    </p>

    <h2 className="section-titles">
      Temple Security Resource Network
    </h2>

    <p>
      ATR will establish a national network of:
    </p>

    <ul>
      <li>Security professionals</li>
      <li>Cybersecurity experts</li>
      <li>Legal advisors</li>
      <li>Crisis management specialists</li>
      <li>Public affairs consultants</li>
    </ul>

    <h2 className="section-titles">
      Training Programs
    </h2>

    <p>
      Regular webinars, workshops, and conferences will be organized
      covering:
    </p>

    <ul>
      <li>Temple security</li>
      <li>Cybersecurity</li>
      <li>Emergency preparedness</li>
      <li>Civic engagement</li>
      <li>Public service leadership</li>
      <li>Media relations</li>
    </ul>

    <h2 className="section-titles">
      Best Practices Handbook
    </h2>

    <p>
      ATR will develop a national Temple Protection & Civic Engagement
      Playbook that temples can adopt and customize for their local needs.
    </p>

    <h2 className="section-titles">
      Temple Leadership Roundtables
    </h2>

    <p>
      Quarterly meetings will allow temple leaders to exchange ideas,
      discuss challenges, and collaborate on solutions.
    </p>

  </div>

  {/* MEMBERSHIP */}

  <div className="section">

    <h2 className="section-title">
      Membership
    </h2>

    <p>
      Any Hindu temple or Hindu religious organization in the United
      States may become an ATR member by contributing only:
    </p>

    <div className="membership-box">

  <a
  href="https://givebutter.com/DONATEA4HNPO"
  className="membership-btn"
  target="_blank"
  rel="noopener noreferrer"
>
  <strong>$101 / YEAR</strong>
</a>

  <div className="payment-info">

  
  <div className="payment-row">

    <div className="payment-card">
      <strong>Make check payable to:</strong><br />
      <strong>AMERICANS4HINDUS</strong>
    </div>

    <div className="payment-card">
      <strong>Mail to:</strong><br />
      <strong>AMERICANS4HINDUS</strong>
      <br />
      <strong>1000 Hunter Lane</strong>
      <br />
      <strong>Fremont, CA 94536</strong>
    </div>

  </div>

</div>

</div>

    <p>
      Membership benefits include:
    </p>

    <ul>
      <li>Access to security resources and guidance</li>
      <li>Participation in ATR training programs</li>
      <li>Civic engagement toolkits</li>
      <li>Networking opportunities with other temples</li>
      <li>Public service and outreach support</li>
      <li>National representation through A4H</li>
    </ul>

  </div>

  {/* VISION */}

  <div className="section">

    <h2 className="section-title">
      Vision
    </h2>

    <p>
      A4H Temple Rakshak envisions every Hindu temple in America becoming:
    </p>

    <ul>
      <li>A secure sanctuary</li>
      <li>A respected community institution</li>
      <li>A center for public service</li>
      <li>A hub of civic engagement</li>
      <li>A guardian of Hindu heritage and values</li>
    </ul>

    <p>
      Together, we can ensure that Hindu temples remain safe, vibrant,
      influential, and respected pillars of American society for
      generations to come.
    </p>

  </div>

</div>

      </div>
    </>
  );
}